import { jsx as _jsx } from "react/jsx-runtime";
import { Button, CircularProgress } from '@mui/material';
const OutlinedButton = (props) => {
    const { color = 'primary', disabled, loading } = props;
    const buttonProps = Object.assign({}, props);
    delete buttonProps['loading'];
    return (_jsx(Button, Object.assign({ variant: "outlined" }, buttonProps, { color: color, disabled: disabled || loading, endIcon: loading ? _jsx(CircularProgress, { size: "1rem" }) : '' })));
};
export default OutlinedButton;
